import React from 'react';
import './styles/LoadingView.scss';

const LoadingView: React.FC = () => {
    return (
        <div className="LoadingView">
            <div className="Content">
                <div className="Spinner"></div>
                <p className="Text">Loading posts...</p>
            </div>
        </div>
    );
};

export default LoadingView;